
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import AppLinearProgressBar from '~/components/AppLinearProgressBar'

@Component({
  components: {
    AppLinearProgressBar,
  },
})
export default class QuizProgressBar extends Vue {
  @Prop({
    required: true,
    default: 100,
    type: Number,
  })
  private readonly max!: number

  @Prop({
    required: true,
    default: 0,
    type: Number,
  })
  private readonly current!: number

  get value () {
    return Math.floor(((this.current - 1) / this.max) * 100)
  }
}
